@if (isOpen) {
  <div class="doc-backdrop" data-testid="documento-modal-backdrop" (click)="cancelar()"></div>

  <div class="doc-container" data-testid="documento-cliente-modal" role="dialog" aria-modal="true"
       aria-labelledby="documento-modal-title" (click)="$event.stopPropagation()">
    <form [formGroup]="form" (ngSubmit)="salvar()" novalidate>
      <div class="doc-header">
        <div>
          <span class="doc-eyebrow">Cadastro do cliente</span>
          <h2 id="documento-modal-title" class="doc-title">Informar CPF/CNPJ</h2>
        </div>
        <button type="button" class="doc-close" [disabled]="carregando()" (click)="cancelar()" aria-label="Fechar">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="doc-banner">
        <span class="doc-banner-label">Cliente</span>
        <span class="doc-banner-value" data-testid="documento-nome-cliente">{{ nomeCliente }}</span>
      </div>

      <div class="doc-body">
        <div class="doc-aviso">
          <i class="bi bi-exclamation-triangle-fill"></i>
          <span>O documento cadastrado para este cliente é inválido. Informe o CPF ou CNPJ correto para prosseguir com a venda.</span>
        </div>

        <label for="documento-cpf-cnpj" class="doc-label">CPF/CNPJ</label>
        <input type="text" id="documento-cpf-cnpj" class="doc-input" formControlName="cpfCnpj"
               data-testid="documento-input" mask="000.000.000-00||00.000.000/0000-00"
               placeholder="Digite o CPF ou CNPJ" autocomplete="off"
               [class.invalid]="form.controls.cpfCnpj.touched && form.controls.cpfCnpj.invalid" />
        @if (form.controls.cpfCnpj.touched && form.controls.cpfCnpj.invalid) {
          <div class="doc-feedback" data-testid="documento-invalido">CPF/CNPJ inválido.</div>
        }

        @if (erro()) {
          <div class="doc-erro" role="alert" data-testid="documento-erro">
            <span class="doc-erro-icon">!</span>
            <span>{{ erro() }}</span>
          </div>
        }
      </div>

      <div class="doc-footer">
        <button type="button" class="btn-cancelar" data-testid="documento-cancelar"
                [disabled]="carregando()" (click)="cancelar()">Cancelar</button>
        <button type="submit" class="btn-salvar" data-testid="documento-salvar"
                [disabled]="salvarDesabilitado">
          @if (carregando()) {
            <span class="spinner-border spinner-border-sm" role="status"></span> Salvando...
          } @else {
            Salvar e continuar
          }
        </button>
      </div>
    </form>
  </div>
}
